import { allMeasurements } from "../constants";
import { KeyLabel } from "../domainConfig";

// The feedback dialog is where coaches type their tape readings, and the tape
// sheet takes the waist at two sites on everyone: across the navel (`waist`)
// and at the narrowest point (`waist_female`). So the dialog asks for both,
// named by site, with the client's own waist (the one the dashboard shows)
// first. The other views keep one waist per sex.
const waistAtNavel: KeyLabel = { key: "waist", label: "Waist at Navel", unit: "cm" };
const narrowestWaist: KeyLabel = { key: "waist_female", label: "Narrowest Waist", unit: "cm" };

export const feedbackMeasurements = (gender: "male" | "female"): KeyLabel[] => {
    const waists = gender === "female" ? [narrowestWaist, waistAtNavel] : [waistAtNavel, narrowestWaist];
    return allMeasurements
        .filter(m => m.key !== "waist_female")
        .flatMap(m => (m.key === "waist" ? waists : [m]));
};

// A scan without a value for a site comes through as undefined or, for
// waist_female, as 0 (data.ts). Neither is a reading a coach can confirm.
export const scannedValue = (value: number | undefined): number | undefined =>
    value !== undefined && Number.isFinite(value) && value > 0 ? value : undefined;
